import { findIndex, flow} from 'lodash'
import { copyWithoutParams } from './objectTrimmer'

export const actionPayloadOnly = copyWithoutParams('type')

export const checkAction = (...actionTypes) => flow(
  (action) => findIndex(actionTypes, (acc) => acc === action.type),
  (found) => found > -1
 )


/** WEBPACK FOOTER **
 ** ./utils/reducerHelper.js
 **/